var map = {
	"./fashi-t.png": 8854,
	"./longqishi-t.png": 1431,
	"./qishi-t.png": 9601,
	"./yemanren-t.png": 7261,
	"./youxia-t.png": 7610,
	"./zhanxingshi-t.png": 8866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6936;